<div *ngIf="imageVisible" style="border: 1px dotted #ddd;border-radius: 0px;padding: 15px 10px;" fxLayout="row"
  fxLayoutAlign="space-between center" fxLayoutGap="10px">
  <div fxLayout="column">
    <span>Figure</span>
    <calsoft-common-images [src]="serverPath+value" [height]="'50px'" [width]="'auto'" [alt]="">
    </calsoft-common-images>
  </div>
  <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
    <button [attr.guide]="'whatsapp-image-btn-1' + '__' + sanitizedUrl" (click)="logo()"
      mat-raised-button>Upload</button>

    <!-- <button [attr.guide]="'whatsapp-image-btn-2' + '__' + sanitizedUrl" *ngIf="value!=''" (click)="deleteImage()" mat-raised-button>delete</button> -->
  </div>
</div>

<div *ngIf="!imageVisible&&!imageDelete" style="border: 1px dotted #ddd;border-radius: 0px;padding: 15px 10px;"
  fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
  <calsoft-common-file-upload (fileUploadResult)=getResult($event) [type]="'whatsapp'" [fileSizeLimit]="fileSizeLimit"
    [allowedMimeType]="allowedMimeType">
  </calsoft-common-file-upload>
</div>